// client/extensions/TextAlign.ts
import TiptapTextAlign from "@tiptap/extension-text-align";
var TextAlignTranslations = {
  textAlign: {
    tooltip: {
      alignLeft: ["Linksb\xFCndig", "Align left"],
      alignCenter: ["Zentriert", "Align center"],
      alignRight: ["Rechtsb\xFCndig", "Align right"],
      justify: ["Blocksatz", "Justify"]
    }
  }
};
var TextAlign = {
  buttons: ({ editor, host }) => [
    {
      name: "alignLeft",
      icon: "format_align_left",
      action: () => editor.chain().focus().setTextAlign("left").run(),
      tooltip: host.translator.translate("tiptap", "textAlign", "tooltip", "alignLeft")
    },
    {
      name: "alignCenter",
      icon: "format_align_center",
      action: () => editor.chain().focus().setTextAlign("center").run(),
      tooltip: host.translator.translate("tiptap", "textAlign", "tooltip", "alignCenter")
    },
    {
      name: "alignRight",
      icon: "format_align_right",
      action: () => editor.chain().focus().setTextAlign("right").run(),
      tooltip: host.translator.translate("tiptap", "textAlign", "tooltip", "alignRight")
    },
    {
      name: "alignJustify",
      icon: "format_align_justify",
      action: () => editor.chain().focus().setTextAlign("justify").run(),
      tooltip: host.translator.translate("tiptap", "textAlign", "tooltip", "justify")
    }
  ],
  extensions: [
    TiptapTextAlign.configure({
      types: ["heading", "paragraph"]
    })
  ]
};
export {
  TextAlign,
  TextAlignTranslations
};
